import React from 'react'
import { Button, Image, StatusBar, StyleSheet, Text, TextInput, TouchableOpacity, View } from 'react-native'
const AppLogo = require('../assets/EasyFill_logo.png')
import { useNavigation } from '@react-navigation/native'

const LoginScreen = () => {
  const navigation = useNavigation()
  
  const signIn = () => {
    console.log('Sign In')
  }

  const signUp = () => {
    console.log('Sign Up')
    navigation.navigate("SignUp")
  }

  return (
    <View style={styles.login}>
      <Image source={AppLogo} style={styles.loginImage} />
      <Text style={styles.loginTitle}>Sign In</Text>
      <Text style={styles.loginText}>Hi there! Nice to see you again.</Text>

      <View style={styles.loginInput}>
        <Text style={styles.loginInputText}>Email</Text>
        <TextInput 
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="email@email.com"
          keyboardType="email-address"
          style={styles.loginInputTextInput}
        />
      </View>

      <View style={styles.loginInput}>
        <Text style={styles.loginInputText}>Password</Text>
        <TextInput 
          autoCapitalize="none"
          autoCorrect={false}
          secureTextEntry={true}
          placeholder="your password here"
          style={styles.loginInputTextInput}
        />
      </View>

      <TouchableOpacity onPress={signIn}>
        <View style={styles.loginButton}>
          <Text style={styles.loginButtonText}>Sign In</Text>
        </View>
      </TouchableOpacity>

      <View style={styles.loginMore}>
        <Text style={styles.loginForgotPassword}>Forgot Password?</Text>

        <TouchableOpacity onPress={signUp}>
          <View>
            <Text style={styles.loginSignUpText}>Sign Up</Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  )
}

export default LoginScreen

const styles = StyleSheet.create({
  login:{
    flex: 1,
    backgroundColor: '#F8F8F8',
    paddingTop: StatusBar.currentHeight,
    paddingHorizontal: "15%",
  },
  loginImage:{
    width: '30vw',
    height: '30vw',
    resizeMode: 'contain',
    marginTop: 50,
    marginHorizontal: 'auto',
  },
  loginTitle:{
    fontSize: 30,
    fontWeight: '500',
    marginTop: 50,
  },
  loginText:{
    fontSize: 16,
    marginBottom: 20,
  },
  loginInput:{
    marginBottom: 20,
  },
  loginInputText:{
    color: '#FF2828',
    fontSize: 16,
    fontWeight: '500',
  },
  loginInputTextInput:{
    //outlineStyle: 'none',
    fontSize: 16,
    fontWeight: '500',
    placeholderTextColor: '#bbb',
    borderBottomWidth: 1,
    borderBottomColor: '#bbb',
    marginTop: 10,
  },
  loginButton:{
    backgroundColor: '#FF2828',
    paddingVertical: 10,
    alignItems: 'center',
    borderRadius: 5,
    marginTop: 20,
  },
  loginButtonText:{
    color: '#F8F8F8',
    fontWeight: '500',
    fontSize: 16,
  },
  loginMore:{
    justifyContent: 'space-between',
    flexDirection: 'row',
    marginTop: 20,
  },
  loginForgotPassword: {
    fontSize: 16,
    color: '#bbb',
    fontWeight: '500',
  },
  loginSignUpText: {
    fontSize: 18,
    color: '#FF2828',
    fontWeight: '500',
  }
})
